import React from "react"

const Footer = () => {
  return (
    <footer className="w-full border-t border-border bg-white text-sm text-muted-foreground">
      <div className="flex h-16 w-full items-center px-4">
        <span>{new Date().getFullYear()} © Ad Pulse.</span>
      </div>
    </footer>
  )
}

export default Footer